<h1 mat-dialog-title>Prezados,</h1>

<div mat-dialog-content>
  <p>
    Para oferecer mais praticidade e agilidade no atendimento, disponibilizamos uma nova funcionalidade no Portal do Credenciado.
  </p>

  <br />

  <p>
    Agora, caso o cliente compareça ao atendimento sem ter realizado o pagamento prévio, o próprio estabelecimento poderá realizar a venda e gerar o link de pagamento para o cliente, diretamente pelo Portal, de forma rápida e segura.
  </p>

  <br />

  <p>
    Para utilizar o recurso, acesse a Área do Credenciado e selecione a opção <strong>"Iniciar Atendimento"</strong>, onde haverá a opção de <strong>"Adicionar novo atendimento"</strong>.
  </p>

  <br />

  <p>
    ⚠️ <strong>Importante:</strong> Clientes que já possuem agendamento pago deverão seguir o fluxo padrão de atendimento: em <strong>"Iniciar Atendimento"</strong>, selecione o agendamento e valide com o código de validação informado pelo cliente.
  </p>

  <br />

  <p>
    Em caso de dúvidas, consulte o tutorial disponível no Portal ou entre em contato com nossa equipe pelos canais de atendimento habituais.
  </p>

  <br>

  <p>
    <strong>Equipe Vale Saúde</strong>
  </p>
</div>

<div mat-dialog-actions>
  <button
    type="button"
    class="dd-m-button-secondary big full"
    mat-dialog-close=""
    data-testid="button-ok"
  >
    Ok
  </button>
</div>
